<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule"  size="small" ref="dataForm"  label-width="120px"
     v-loading="dataLoading" style="width:100%;"  element-loading-text=""  element-loading-spinner="el-icon-loading"
    >
      <el-form-item label="应用行业编号" prop="industryNo">
        <el-input v-model="dataForm.industryNo" placeholder="应用行业编号"  size="small" maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="应用行业名称" prop="industryName">
        <el-input v-model="dataForm.industryName" placeholder="应用行业名称"  size="small" maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="应用行业说明" prop="description">
        <div style="margin: 20px 0;"></div>
        <el-input
                type="textarea"
                :rows="5"
                placeholder="应用行业说明"
                v-model="dataForm.description"
                maxlength="150"
                show-word-limit
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="small">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()" size="small"  :disabled="dataLoading">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {info,add,update} from '@/api/modules/industry'
  export default {
    data () {
      return {
        visible: false,
        dataLoading: false,
        dataForm: {
          id: 0,
          industryNo: '',
          industryName: '',
          description: ''
        },
        dataRule: {
          industryNo: [
            { required: true, message: '应用行业编号不能为空', trigger: 'blur' }
          ],
          industryName: [
            { required: true, message: '应用行业名称不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id || 0
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            info({id:this.dataForm.id}).then(({data}) => {
              if (data && data.code === 0) {
                this.dataForm.industryNo = data.industry.industryNo
                this.dataForm.industryName = data.industry.industryName
                this.dataForm.description = data.industry.description
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
          	this.dataLoading = true;
            var params = {
              'id': this.dataForm.id || undefined,
              'industryNo': this.dataForm.industryNo,
              'industryName': this.dataForm.industryName,
              'description': this.dataForm.description
            }
            var tick = !this.dataForm.id ? add(params) : update(params)
            tick.then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false;
	              	this.dataLoading = false;
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
                this.dataLoading = false;
              }
            })
          }
        })
      }
    }
  }
</script>
